import { render, staticRenderFns } from "./sendmoney-checkout-status.vue?vue&type=template&id=77198721&"
import script from "./sendmoney-checkout-status.vue?vue&type=script&lang=js&"
export * from "./sendmoney-checkout-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports